import React from 'react';
import NotesMainPanel from '../../components/workspace/NotesMainPanel';
import { useDashboardData } from '../../components/DashboardShell';
import { useLocale } from '../../context/LocaleContext';

export default function BonnieScenarios() {
  const { data } = useDashboardData();
  const { t } = useLocale();
  const items = data?.bonnie?.scenarios || [];
  return (
    <NotesMainPanel
      title={t('bonnie.scenariosTitle')}
      subtitle={t('bonnie.scenariosSubtitle')}
      items={items}
      emptyTitle={t('bonnie.scenariosEmpty')}
    />
  );
}
